export const mattressCdnUrls = {
    images: {
        onePersonEvolve:
            "https://cdn.api.auping.com/sites/default/files/2023-05/one-person-evolve-new.jpg",
        onePersonTwo:
            "https://cdn.api.auping.com/sites/default/files/2024-07/Two_1p_white.jpg",
        onePersonOne:
            "https://cdn.api.auping.com/sites/default/files/2024-07/One_1p_white.jpg",
        onePersonElysium:
            "https://cdn.api.auping.com/sites/default/files/2024-07/Elysium_1p_white.jpg",
        onePersonElite:
            "https://cdn.api.auping.com/sites/default/files/2023-05/one-person-elite.jpg",
        twoPersonEvolve:
            "https://cdn.api.auping.com/sites/default/files/2023-05/two-person-evolve-new.jpg",
        twoPersonTwo:
            "https://cdn.api.auping.com/sites/default/files/2024-07/Two_2p_white.jpg",
        twoPersonOne:
            "https://cdn.api.auping.com/sites/default/files/2024-07/One_2p_white.jpg",
        twoPersonElysium:
            "https://cdn.api.auping.com/sites/default/files/2024-07/Elysium_2p_white.jpg",
        twoPersonElite:
            "https://cdn.api.auping.com/sites/default/files/2023-05/two-person-elite.jpg"
    },
};

export const selectedMattressCdnUrls = {
    images: {
        onePersonEvolveSelected:
            "https://cdn.api.auping.com/sites/default/files/2023-05/one-person-evolve-new-selected.jpg",
        onePersonTwoSelected:
            "https://cdn.api.auping.com/sites/default/files/2024-07/Two_1p_blue.jpg",
        onePersonOneSelected:
            "https://cdn.api.auping.com/sites/default/files/2024-07/One_1p_white.jpg",
        onePersonElysiumSelected:
            "https://cdn.api.auping.com/sites/default/files/2024-07/Elysium_1p_blue.jpg",
        onePersonEliteSelected:
            "https://cdn.api.auping.com/sites/default/files/2023-05/one-person-elite-new-selected.jpg",
        twoPersonEvolveSelected:
            "https://cdn.api.auping.com/sites/default/files/2023-05/two-person-evolve-new-selected.jpg",
        twoPersonTwoSelected:
            "https://cdn.api.auping.com/sites/default/files/2024-07/Two_2p_blue.jpg",
        twoPersonOneSelected:
            "https://cdn.api.auping.com/sites/default/files/2024-07/One_2p_white.jpg",
        twoPersonElysiumSelected:
            "https://cdn.api.auping.com/sites/default/files/2024-07/Elysium_2p_blue.jpg",
        twoPersonEliteSelected:
            "https://cdn.api.auping.com/sites/default/files/2023-05/two-person-elite-new-selected.jpg"
    }
};
